<template>
  <div>
    <div class="relative inline-block text-left">
      <div>
        <span class="rounded-md shadow-sm">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150"
            id="options-menu"
            aria-haspopup="true"
            aria-expanded="true"
            @click="isOpen = !isOpen"
          >
            Insert variable
            <svg
              class="-mr-1 ml-2 h-5 w-5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </span>
      </div>

      <transition
        enter-active-class="transition ease-out duration-100 transform"
        enter-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-active-class="transition ease-in duration-75 transform"
        leave-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
      >
        <div
          class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg z-10"
          style="max-height: 300px; overflow: auto"
          v-show="isOpen"
        >
          <div
            class="rounded-md bg-white shadow-xs"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          >
            <div class="py-1">
              <a
                v-for="(variable, index) in variables"
                :key="index"
                class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                role="menuitem"
                @click="itemClicked(variable)"
                >{{ variable.label }}
              </a>
            </div>
            <div class="border-t border-gray-100"></div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    templateType: {
      type: String
    }
  },
  data() {
    return {
      isOpen: false,
      abandonedCartvariables: [
        { label: "First name", value: "{firstName}" },
        { label: "Last name", value: "{lastName}" },
        { label: "Shop url", value: "{shopUrl}" },
        { label: "Checkout url", value: "{checkoutUrl}" },
        { label: "Total amount", value: "{totalAmount}" }
      ],
      orderVariables: [
        { label: "First name", value: "{firstName}" },
        { label: "Last name", value: "{lastName}" },
        { label: "Shop url", value: "{shopUrl}" },
        { label: "Order status url", value: "{orderStatusUrl}" },
        { label: "Total amount", value: "{totalAmount}" },
        { label: "Order Id", value: "{orderId}" },
        { label: "Order items", value: "{orderItems}" },
        { label: "Shipping address", value: "{shippingAddress}" },
        { label: "Tracking Number", value: "{trackingNumber}" },
        { label: "Tracking url", value: "{trackingUrl}" }
      ],
      marketingVariables: [{ label: "First name", value: "{first_name}" }]
    };
  },
  computed: {
    variables() {
      if (this.templateType === "Abandoned") {
        return this.abandonedCartvariables;
      }
      if (this.templateType === "marketing") {
        return this.marketingVariables;
      }
      return this.orderVariables;
    }
  },
  created() {
    window.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    itemClicked(variable) {
      this.$emit("onItemClicked", variable.value);
      this.isOpen = false;
    },
    handleOutsideClick(e) {
      // close dropdown when clicked outside
      if (!this.$el.contains(e.target)) {
        this.dropDropdown = false;
        this.isOpen = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
